import type { PublicPaymentPlanStage } from '@/components/public/PaymentPlanPreview';

const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

/**
 * Render a stage's resolved amount.
 *
 * `amount.amount` is the RESOLVED dollar value — a 25%-of-total rule on a $339
 * job resolves to 84.75 — not the authored percent. Treating those dollars as a
 * percentage once printed $250 as "250%", so this currency-formats them to
 * match the PDF and the customer-facing quote, which both show "$84.75".
 *
 * Its own module rather than a component file: three surfaces import it, and
 * exporting a helper alongside a component breaks fast refresh.
 */
export function formatStageAmount(amount: PublicPaymentPlanStage['amount']): string {
  if (amount.amount === null) return 'Remaining balance';
  return currency.format(amount.amount);
}
